<template>
  <div 
    id="biochemical_oxygen_ship"
    class="biochemical_oxygen"
  >
    <div 
      v-if="receivedData"
      class="biochemical_oxygen-item"
    >
      <CastomGraphic
          :received-data="receivedData[0]"
          graph-type="line"
          index-axis="x"
          :id="'biochemical_oxygen_ship-1'"
          :aspect-ratio="1"
          :maintain-aspect-ratio="true"
      />
    </div>  
    <div 
      v-if="receivedData"
      class="biochemical_oxygen-item"
    >
      <CastomGraphic
          :received-data="receivedData[1]"
          graph-type="line"
          index-axis="x"
          :id="'biochemical_oxygen_ship-2'"
          :aspect-ratio="1"
          :maintain-aspect-ratio="true"
      />
    </div>  
  </div>
</template>
<script>

import CMS from '@/model/cms'
import Service from '@/service/service.js'
import { mapGetters } from 'vuex'

export default {
  name: 'BiochemicalOxygen',
  
  components: {
    CastomGraphic: () => import('@/components/graph/CastomGraphic.vue'),
  },

  computed: {
    ...mapGetters({
      userToken: 'getUserToken'
    }),
  },

  data () {
    return {
      receivedData: null,
      blockId: 'biochemical_oxygen',
      cloneElementId: 'biochemical_oxygen_ship'
    }
  },

  mounted() {
    this.getGraphData()
    Service.elementClone(this.blockId, this.cloneElementId)
  },

  methods: {
    getGraphData() {
      CMS.getGraph(this.userToken, '84,85').then((response) => {
        this.receivedData = response.data
      })
    }
  }
}
</script>
<style lang="scss" scoped>
</style>